module.exports = __webpack_public_path__ + "static/media/toolbar-pin.22b8bc6e.svg";